import type { LucideIcon } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string;
  trend?: string;
  tone?: 'default' | 'good' | 'warning' | 'danger' | 'blue';
  icon: LucideIcon;
}

const toneClass = {
  default: 'text-console-text',
  good: 'text-console-good',
  warning: 'text-console-half',
  danger: 'text-red-300',
  blue: 'text-console-blueSoft',
};

export function MetricCard({ title, value, trend, tone = 'default', icon: Icon }: MetricCardProps) {
  return (
    <section className="console-card p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="console-label">{title}</p>
          <p className={`console-value mt-3 text-3xl ${toneClass[tone]}`}>{value}</p>
          {trend && <p className="mt-2 font-mono text-xs text-console-muted">{trend}</p>}
        </div>
        <div className="rounded-md border border-console-border bg-console-panelHigh p-2 text-console-blueSoft">
          <Icon size={20} strokeWidth={1.8} />
        </div>
      </div>
    </section>
  );
}
